import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';

import {
	VehicleType,
	ControlConfiguration,
	EasyClaimDocumentType,
} from '../easyclaim.api.client.typescript/src/index';
import { DetailsContainer } from '../easyclaim.app.components/index';
import CustomerConfigurationContext from '../easyclaim.app.contexts/CustomerConfigurationContextCore';

import { CarBackLeftControl } from './Controls/CarBackLeftControl';
import { CarBackRightControl } from './Controls/CarBackRightControl';
import { CarFrontLeftControl } from './Controls/CarFrontLeftControl';
import { CarFrontRightControl } from './Controls/CarFrontRightControl';
import { ScooterBackLeftControl } from './Controls/ScooterBackLeftControl';
import { ScooterBackRightControl } from './Controls/ScooterBackRightControl';
import { ScooterFrontLeftControl } from './Controls/ScooterFrontLeftControl';
import { ScooterFrontRightControl } from './Controls/ScooterFrontRightControl';
import { ScreenComponent } from './ScreenComponent';

export interface FourDiagonalPerspectivesProps extends AppState {
	screenConfiguration: ControlConfiguration[];
	enableMotorbikesSupport: boolean;
}

export class FourDiagonalPerspectives extends ScreenComponent<FourDiagonalPerspectivesProps, {}> {
	public render() {
		const vehicleTypeId = this.props.easyClaimCase?.vehicle?.vehicleTypeId;
		const motorbikesSupport = this.props.enableMotorbikesSupport;

		return (
			<CustomerConfigurationContext.Consumer>
				{({ configuration }) => {
					const isProgressBarEnabled = configuration?.isImageUploadProgressBarVisible;

					return (
						<div className="main-container">
							{!!isProgressBarEnabled || (
								<h2 className="four-diagonal-perspectives-title">
									<FormattedMessage id="vehicleImages.overviewPhotos" />
								</h2>
							)}
							<h3 className="four-diagonal-perspectives-subtitle">
								<FormattedMessage id="vehicleImages.overviewPhotos.subtitle" />
							</h3>
							<p className="four-diagonal-perspectives-description">
								<FormattedMessage
									id={
										vehicleTypeId === VehicleType.Motorbike && motorbikesSupport
											? 'vehicleImages.description.motorbike'
											: 'vehicleImages.description'
									}
								/>
							</p>
							<DetailsContainer className="four-diagonal-perspectives-container">
								{this.props.screenConfiguration.map((controlConfiguration) => {
									if (vehicleTypeId === VehicleType.Motorbike && motorbikesSupport) {
										switch (controlConfiguration.documentType) {
											case EasyClaimDocumentType.FrontLeftPicture:
												return (
													<ScooterFrontLeftControl
														key={controlConfiguration.documentType}
														{...this.props}
													/>
												);
											case EasyClaimDocumentType.RearLeftPicture:
												return (
													<ScooterBackLeftControl
														key={controlConfiguration.documentType}
														{...this.props}
													/>
												);
											case EasyClaimDocumentType.RearRightPicture:
												return (
													<ScooterBackRightControl
														key={controlConfiguration.documentType}
														{...this.props}
													/>
												);
											case EasyClaimDocumentType.FrontRightPicture:
												return (
													<ScooterFrontRightControl
														key={controlConfiguration.documentType}
														{...this.props}
													/>
												);
											default:
												return null;
										}
									} else {
										switch (controlConfiguration.documentType) {
											case EasyClaimDocumentType.FrontLeftPicture:
												return (
													<CarFrontLeftControl
														key={controlConfiguration.documentType}
														{...this.props}
													/>
												);
											case EasyClaimDocumentType.RearLeftPicture:
												return (
													<CarBackLeftControl
														key={controlConfiguration.documentType}
														{...this.props}
													/>
												);
											case EasyClaimDocumentType.RearRightPicture:
												return (
													<CarBackRightControl
														key={controlConfiguration.documentType}
														{...this.props}
													/>
												);
											case EasyClaimDocumentType.FrontRightPicture:
												return (
													<CarFrontRightControl
														key={controlConfiguration.documentType}
														{...this.props}
													/>
												);
											default:
												return null;
										}
									}
								})}
							</DetailsContainer>
						</div>
					);
				}}
			</CustomerConfigurationContext.Consumer>
		);
	}
}
